export class CreditCard {
    csrfToken: string;
    cardHolderName: string = "";
    cardNo: string = "";
    cardSecureId: string = "";
    cardExpiry:string = "";
    paymentAmount:string = "";
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }

    fromJSON(json) {
        for (var propName in json){
            this[propName] = json[propName];
        }
        return this;
    }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/CreditCard.ts